<button
  [attr.id]="buttonInput?.id"
  [attr.type]="buttonInput?.type"
  [disabled]="buttonInput?.disabled || buttonInput?.loading"
  [class]="[
    'btn',
    'btn-' + buttonInput?.color,
    'btn-' + buttonInput?.color + '--' + buttonInput?.size,
    buttonInput?.block ? 'btn-block' : '',
    buttonInput?.icon ? 'is-icon-md' : '',
    buttonInput?.extraClasses || ''
  ]"
  [attr.aria-label]="buttonInput?.ariaLabel || buttonInput?.label"
  (click)="onClick($event)"
>
  @if (buttonInput?.icon && buttonInput?.iconPosition === 'left') {
    <img [src]="buttonInput?.icon" alt="" />
  }
  @if (buttonInput?.loading) {
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
  }
  {{ buttonInput?.label }}
  @if (buttonInput?.icon && buttonInput?.iconPosition === 'right') {
    <img [src]="buttonInput?.icon" alt="" />
  }
</button>